var map = {
	"./banner.jpg": 599,
	"./cmc-clone.jpg": 894,
	"./crowdfund.jpg": 581,
	"./crypto-calculator.jpg": 964,
	"./dashboard3.jpg": 755,
	"./full-mint.jpg": 795,
	"./krypt.jpg": 103,
	"./lazy-mint.jpg": 565,
	"./market-sentiment.jpg": 597,
	"./nft-y.jpg": 396,
	"./secret-recipe.jpg": 662,
	"./spooky-hollow.jpg": 114,
	"./twitter-clone.jpg": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;